module.exports = __webpack_public_path__ + "img/haverim_yes.91f96711.png";